"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ClayButtonWithIcon", {
  enumerable: true,
  get: function get() {
    return _ButtonWithIcon.default;
  }
});
exports.default = void 0;
var _Button = _interopRequireDefault(require("./Button"));
var _ButtonWithIcon = _interopRequireDefault(require("./ButtonWithIcon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
var _default = exports.default = _Button.default;